export const LangText: any = {
    us: {
        product_name: 'EcoFlow DELTA 3 Max Series (2048Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Buy Now',
    },
    jp: {
        product_name: 'EcoFlow DELTA 3 Max シリーズ (2048Wh)',
        tab_product: '概要',
        tab_bundles: 'Bundles',
        tab_support: 'サポート',
        tab_specs: '仕様',
        tab_media: 'Media',
        btn_buy: '今すぐ予約',
        btn_buy2: '今すぐ購入',
    },
};
